<template>
	<div :class="getClassName">
		<div class="item">
			<div class="image-container">
				<router-link
					class="item-img-wrapper-link"
					:to="{
						name: 'ProductDetail',
						params: {id: product.id, slug: product.product_slug},
					}"
					target="_blank"
				>
					<img
						class="img-fluid"
						v-lazy="{
							src:
								API_URL +
								'/storage/uploads/' +
								(product.images.length > 0 ? product.images[0].name : 'no_image.png'),
							loading: publicPath + 'assets/images/spinner.gif',
							error: publicPath + 'assets/images/not_found.png',
						}"
					/>
				</router-link>
				<div class="item-action-behaviors" v-if="product.lowest_price_stock != 0">
					<a class="item-quick-look" data-toggle="modal" href="#quick-view">Quick Look</a>
					<a class="item-mail" href="javascript:void(0)">Mail</a>
					<a
						class="item-addwishlist"
						href="javascript:void(0)"
						@click.prevent="
							addToWishlist({
								product_id: product.id,
								product_combination_id: product.lowest_price_relation.product_combination_id,
								warehouse_id: product.lowest_price_relation.warehouse_id,
							})
						"
						>Add to Wishlist</a
					>
					<a
						class="item-addCart"
						href="javascript:void(0)"
						@click.prevent="
							addToCart({
								product_id: product.id,
								product_combination_id: product.lowest_price_relation.product_combination_id,
								price: product.lowest_price,
								warehouse_id: product.lowest_price_relation.warehouse_id,
							})
						"
						>Add to Cart</a
					>
				</div>
			</div>
			<div class="item-content">
				<div class="what-product-is">
					<ul class="bread-crumb">
						<li class="">
							<router-link
								:to="{
									name: 'ProductsByCategory',
									params: {id: product.category.id, slug: product.category.category_slug},
								}"
								>{{ product.category.name }}</router-link
							>
						</li>
					</ul>
					<h6 class="item-title">
						<router-link
							:to="{
								name: 'ProductDetail',
								params: {id: product.id, slug: product.product_slug},
							}"
							target="_blank"
							>{{ product.product_name }}</router-link
						>
					</h6>
					<!-- <div class="item-description">
						<p>
							This hoodie is full cotton. It includes a muff sewn onto the lower front, and
							(usually) a drawstring to adjust the hood opening. Throughout the U.S., it is
							common for middle-school, high-school, and college students to wear this
							sweatshirts—with or without hoods—that display their respective school names or
							mascots across the chest, either as part of a uniform or personal preference.
						</p>
					</div> -->
					<div class="item-stars">
						<StarRating
							:rating="product.avg_rating"
							:star-size="20"
							:read-only="true"
							:show-rating="false"
						/>
					</div>
				</div>

				<div class="price-template">
					<div class="item-new-price">
						{{
							product.lowest_price_stock == "0"
								? "Out of stock"
								: formatCurrency(product.lowest_price)
						}}
					</div>
				</div>
			</div>
			<div class="tag sale" v-if="product.featured && sortBy == 'featured'">
				<span><i class="fa fa-star"></i></span>
			</div>
			<div class="tag new" v-else>
				<span>New</span>
			</div>
		</div>
	</div>
	<vue-element-loading
		:active="status.cart.loading && !getStatus.products.loading"
		spinner="spinner"
		is-full-screen
		color="#343a40"
		text="Adding Product"
	/>
	<vue-element-loading
		:active="wishlistStatus.addToWishlist.loading"
		spinner="spinner"
		is-full-screen
		color="#343a40"
		text="Adding To Wishlist"
	/>
</template>

<script>
	import StarRating from "vue-star-rating";
	import {formatCurrency} from "../../utils/common_functions";
	import {mapGetters, mapActions} from "vuex";
	import {publicPath} from "../../../vue.config";
	export default {
		props: ["product", "sortBy", "className"],
		computed: {
			...mapGetters("products", ["getStatus"]),
			...mapGetters("cart", ["status"]),
			...mapGetters({wishlistStatus: "wishlist/status"}),
			getClassName() {
				return this.className || "product-item col-lg-4 col-md-6 col-sm-6";
			},
		},
		components: {StarRating},
		data() {
			return {
				API_URL: process.env.VUE_APP_API_URL,
				publicPath: publicPath,
			};
		},
		methods: {
			formatCurrency,
			...mapActions("products", ["getProductByCategoryId", "fetchBrands"]),
			...mapActions("cart", ["addToCart"]),
			...mapActions("wishlist", ["addProductToWislist"]),
			_addToCart(data) {
				this.addToCart(data);
			},
			addToWishlist(data) {
				this.addProductToWislist(data);
			},
		},
	};
</script>

<style></style>
